import { useTranslation } from "react-i18next";
import { useAppState } from "../../context/AppStateContext";
import { useHardwareSnapshot } from "../../lib/hardwareStore";

/** Shown on every screen while receipts are waiting for a reprint: the sale is saved but the customer has no paper yet. */
export function FailedReceiptsBanner() {
  const { t } = useTranslation();
  const { tab, setTab } = useAppState();
  const hw = useHardwareSnapshot();
  if (!hw.native || hw.failed.length === 0 || tab === "hardware") return null;
  return (
    <div role="alert" className="flex flex-wrap items-center justify-between gap-2 bg-red-600 px-5 py-2 text-xs font-bold text-white">
      <span>⚠️ {t("hw.banner", { count: hw.failed.length })}{hw.status?.lastError ? ` — ${hw.status.lastError}` : ""}</span>
      <button type="button" className="rounded-lg bg-white/20 px-3 py-1 font-black hover:bg-white/30" onClick={() => setTab("hardware")}>{t("hw.failed.reprint")}</button>
    </div>
  );
}
